import { useTranslation } from "@1f/react-sdk";

import Modal from "@vapor/react-material/Modal";
import Box from "@vapor/react-material/Box";
import Stack from "@vapor/react-material/Stack";
import Divider from "@vapor/react-material/Divider";
import Button from "@vapor/react-material/Button";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";

export const IdentModal = ({ open, onClose, onOk }) => {
  const { t } = useTranslation();

  return (
    <Modal
      key="identModal"
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      open={open}
      onClose={onClose}
      onBackdropClick={onClose}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "400px",
          minHeight: "230px",
          bgcolor: "#FFFFFF",
          boxShadow: "0px 0px 8px 0px #CCCCCC",
        }}
      >
        <Stack
          direction="column"
          spacing={0}
          justifyContent="left"
          alignItems="left"
        >
          <ExtendedTypography
            variant="titleSmall"
            color="primary.main"
            sx={{ p: 2, pl: 3 }}
          >
            Attenzione
          </ExtendedTypography>
          <Divider orientation="horizontal" flexItem />
        </Stack>
        <Stack
          direction="column"
          spacing={0}
          justifyContent="left"
          alignItems="left"
        >
          <Box sx={{ pl: 3, pr: 3, pb: 2, pt: 3 }}>
            <ExtendedTypography variant="body" color="primary.main">
              {t("anagrafica.anagraficaForm.ambiProf")}
              <br />
              {t("anagrafica.anagraficaForm.wntProc")}
            </ExtendedTypography>
          </Box>
        </Stack>
        <Stack
          direction="row"
          spacing={1}
          sx={{
            p: 1,
            mt: 1,
            bgcolor: "#F2F5F8",
            position: "fixed",
            bottom: 0,
            width: "100%",
          }}
          justifyContent="right"
          alignItems="right"
        >
          <Button variant="outlined" size="small" onClick={onClose}>
            {t("actions.annulla")}
          </Button>
          <Button variant="contained" size="small" onClick={onOk}>
            Conferma
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};
